export const updateInfluencer = (influencers, newInfluencer) => {
  return influencers.map(influencer => {
    if (influencer.slug === newInfluencer.slug) {
      return { ...influencer, ...newInfluencer };
    }
    return influencer;
  });
};
